import { createContext, useContext } from 'react';
import { GetUserResponseProps } from 'api/types';

export type AuthContextProps = {
  user: GetUserResponseProps;
  setUser: (values: any) => void;
  isLoggingOut: boolean;
  setIsLoggingOut: (value: boolean) => void;
};

export const AuthContext = createContext<AuthContextProps>({
  user: {} as GetUserResponseProps,
  setUser: () => console.log('setUser'),
  isLoggingOut: false,
  setIsLoggingOut: () => console.log('setIsLoggingOut'),
});

export const useAuth = (): Readonly<AuthContextProps> => useContext(AuthContext);
